import { LearnersEmailConsent } from './reducers';
import { addReducer } from '../../../ReduxStorage/Store';

const injectReducers = () => {
  addReducer('LearnersEmailConsent', LearnersEmailConsent);
};

injectReducers();

if (module.hot) {
  // If the reducer code is updated, don't reload the page, just update the store/reducer
  module.hot.accept('./reducers', injectReducers);
}
